var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_11303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8713 12.4213V19.3778",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1645 15.6338C15.0365 14.3104 14.3388 13.5767 13.0685 12.5036C13.0077 12.4521 12.9311 12.4231 12.8515 12.4216C12.7718 12.42 12.6941 12.4459 12.6314 12.495C11.3714 13.4824 10.6599 14.2213 9.50452 15.6338",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29993 10.995L4.97021 20.3893C5.08164 21.927 6.2045 23.2196 7.73364 23.4236C11.1622 23.883 14.5805 23.883 18.0091 23.4236C19.5382 23.2196 20.6611 21.927 20.7725 20.3893L21.4428 10.995",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1571 6.83784H23.5857",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58569 6.70927L9.42055 4.41212C9.67813 3.70376 10.1475 3.09182 10.7648 2.65939C11.3822 2.22696 12.1177 1.99499 12.8714 1.99498C14.4143 1.99498 15.7943 2.96012 16.3223 4.41212L17.1571 6.70927",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_11303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.871338 0.880692)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9d810e7a69349bada1da54e4f71fd401.svg";
export { ForwardRef as ReactComponent };